import { render, staticRenderFns } from "./BlogImage.vue?vue&type=template&id=1be89694&scoped=true"
import script from "./BlogImage.vue?vue&type=script&lang=js"
export * from "./BlogImage.vue?vue&type=script&lang=js"
import style0 from "./BlogImage.vue?vue&type=style&index=0&id=1be89694&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be89694",
  null
  
)

export default component.exports